import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Header from "./Header";
import { Helmet } from "react-helmet";

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Bliss Water Technology</title>
        <meta
          name="description"
          content="Review the terms and conditions for purchasing, installation, and servicing of water filters, geysers, pumps, and membranes at Bliss Water Technology."
        />
        <meta
          name="keywords"
          content="Terms and Conditions, water filter installation, geyser service, pump fitting, membrane sale, RO filter terms, Bliss Water Technology, water filtration system policies"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HeadingNavbar />
      <Header />

      <Container>
        <Row className="my-md-5 my-4">
          <Col>
            <Card.Title className="text-center fs-2 mb-3 fw-bold">
              Terms & Conditions
            </Card.Title>
            <Card>
              <Card.Body className="mt-2">
                <Card.Text as="div">
                  <section>
                    <h5 className="fw-bold">Introduction</h5>
                    <p>
                      Welcome to <strong>Bliss Water Technology</strong>! We
                      provide the sales, installation, and servicing of
                      high-quality <strong>Water Filters</strong>,{" "}
                      <strong>Geysers</strong>, <strong>Pumps</strong>, and{" "}
                      <strong>Membranes</strong>. Our aim is to ensure reliable
                      and affordable solutions for residential and commercial
                      water needs.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Use of Services</h5>
                    <p>
                      By accessing or purchasing from our website or physical
                      location, you agree to comply with the terms related to
                      product purchase, installation (fitting), and post-sale
                      services provided by Bliss Water Technology.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Product Information</h5>
                    <p>
                      We offer only new and genuine products. All
                      specifications, features, and warranties are provided in
                      the product listings. Customers are encouraged to read the
                      full details before making a purchase.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Installation & Service</h5>
                    <p>
                      Installation and on-site fitting services are available
                      for all products. Service appointments can be scheduled
                      through our support channels. Service charges may vary
                      based on the product and location.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Pricing and Payment</h5>
                    <p>
                      Product and service pricing is clearly mentioned. We
                      accept multiple secure payment methods including cash,
                      UPI, and digital payments. Payment must be completed at
                      the time of purchase or as agreed during installation.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Returns and Warranty</h5>
                    <p>
                      All products come with manufacturer warranties. Returns
                      are accepted only for defective or damaged items as per
                      our return policy. Installation and service issues should
                      be reported within 48 hours.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Limitation of Liability</h5>
                    <p>
                      Bliss Water Technology is not responsible for any damage
                      caused due to improper use or third-party installation.
                      Liability is limited to product cost and/or service
                      warranties as stated.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Changes to Terms</h5>
                    <p>
                      We may update these Terms & Conditions without prior
                      notice. Changes will be effective immediately after
                      posting. Continued use of our services implies your
                      acceptance of the updated terms.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Contact Us</h5>
                    <p>
                      For inquiries or support regarding product purchases, installations, or services, contact us at{" "}
                      <a href="mailto:blisswatertechnology@gmail.com">blisswatertechnology@gmail.com</a>{" "}
                      or call our support team at{" "}
                      <a href="tel:+919265199516">+91 92651 99516</a>. We're here to help!
                    </p>
                  </section>

                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default TermsAndConditions;
